import { useContext } from "react";
import { EsriContext } from "../providers/EsriContext";

const useEsri = () => {
  const context = useContext(EsriContext);
  if (context === undefined) {
    throw new Error("must be used within <EsriProvider/>");
  }
  return context;
};

export default useEsri;
